















































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { LogAlertaPrescRelatorioFiltrosDTO } from '@/interfaces/alerts-prescription-report';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import * as service from '@/services/alerts-prescriptions-report';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiSelectClients,
    UiDatePickerRange,
    UiSelectDoctor
  }
})
export default class AlertsPrescriptionsReport extends BaseComponent {
  filter: any = {};

  productsLoading = false;
  products = [];

  codesLoading = false;
  codes = [];

  error = false;
  loading = false;
  loadingXls = false;
  executed = false;

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      periodo: [(v) => !!v || 'Escolha uma data ou período']
    }
  };

  headers = [
    { text: 'Unidade/Cliente', value: 'nomeUnidade', sortable: true },
    { text: 'Médico', value: 'nomeMedico', sortable: true },
    { text: 'Código da Regra', value: 'codigoRestricao', sortable: true, align: 'center' },
    { text: 'Descrição', value: 'descricaoRestricao', sortable: true },
    { text: 'Quantidade', value: 'quantidade', sortable: true, align: 'center' },
    { text: 'Prescrições', value: 'prescricoes', sortable: false }
  ];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.loadCodes();
    this.loadProducts();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listDataAlertsPrescriptionsReport(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res;
          this.loading = false;
          this.pagination.page = 1;
          this.executed = true;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      );
  }

  loadProducts() {
    this.productsLoading = true;
    service.listProductsAlertsPrescriptionsReport().subscribe(
      (res) => {
        this.products = res;
        this.productsLoading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.productsLoading = false;
      }
    );
  }

  loadCodes() {
    this.codesLoading = true;
    service.listCodesAlertsPrescriptionsReport().subscribe(
      (res) => {
        this.codes = res;
        this.codesLoading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.codesLoading = false;
      }
    );
  }

  public exec() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.executed = false;
    this.loading = true;
    this.error = false;

    let parm = this.buildFilterParm();
    this.execBehaviorSub$.next(parm);
  }

  private buildFilterParm() {
    let parm = new LogAlertaPrescRelatorioFiltrosDTO();
    let filter = this.filter;

    parm.dataIni = filter.periodo && filter.periodo.length > 0 ? filter.periodo[0] : null;
    parm.dataFim = filter.periodo && filter.periodo.length > 1 ? filter.periodo[1] : null;
    parm.idsProdutos = filter.idsProdutos;
    parm.idsClientes = filter.clients ? filter.clients.map((u) => u.id) : [];
    parm.idsUnidades = filter.clientUnits ? filter.clientUnits.map((u) => u.id) : [];
    parm.cdsRestricoes = filter.cdsRestricoes;
    parm.idsMedicos = filter.medicos ? filter.medicos.map((m) => m.id) : [];

    return parm;
  }

  public exportXls() {
    this.loader.start('Gerando XLS...');
    this.loadingXls = true;
    let parm = this.buildFilterParm();

    service.buildAlertsPrescriptionsXlsReport(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.loadingXls = false;
        this.forceFileAxiosResponseDownload(res, 'relatorio.xls');
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      }
    );
  }
}
